/**
 * Hover pan for background images: inside any [data-hover-pan] element, the background image
 * zooms in slightly on hover and drifts gently opposite the pointer for a sense of depth.
 * Writes --pan-x / --pan-y (-1…1) and data-panning on the element; CSS in config/styles.css
 * does the motion. Uses one delegated listener on the document, so it keeps working when the
 * editor or a partial re-render replaces the banner. Skipped on touch and reduced motion.
 */
const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce), (max-width: 767px), (hover: none)');

let active = null;
let frame = 0;

function reset(el) {
  el.style.setProperty('--pan-x', '0');
  el.style.setProperty('--pan-y', '0');
  el.removeAttribute('data-panning');
}

document.addEventListener(
  'pointermove',
  (event) => {
    if (!canHover.matches || reducedMotion.matches) return;
    const el = event.target instanceof Element ? event.target.closest('[data-hover-pan]') : null;

    if (active && active !== el) reset(active);
    active = el;
    if (!el) return;

    const { clientX, clientY } = event;
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      const rect = el.getBoundingClientRect();
      const x = ((clientX - rect.left) / rect.width) * 2 - 1;
      const y = ((clientY - rect.top) / rect.height) * 2 - 1;
      el.style.setProperty('--pan-x', x.toFixed(3));
      el.style.setProperty('--pan-y', y.toFixed(3));
      el.setAttribute('data-panning', '');
    });
  },
  { passive: true }
);

document.addEventListener('pointerout', (event) => {
  if (!active) return;
  const next = event.relatedTarget instanceof Element ? event.relatedTarget.closest('[data-hover-pan]') : null;
  if (next !== active) {
    cancelAnimationFrame(frame);
    reset(active);
    active = null;
  }
});
